var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"id":_vm.control.uniqueId,"name":_vm.control.name || _vm.control.uniqueId,"disabled":_vm.control.isDisabled},on:{"click":function($event){return _vm.updateValue(_vm.switchValue)}},model:{value:(_vm.switchValue),callback:function ($$v) {_vm.switchValue=$$v},expression:"switchValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }